module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av552-a1b90f4e22b1c940ce0a178af2bc86a0.jpg";